import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { ProcessoService } from '../../services/processo.service';
import { EventoProcesso, ProcessoExecucao, ProcessoExecucaoDetalhe, ProcessoFiltro, StatusProcesso } from '../../types/ProcessoExecucao.type';

@Component({
  selector: 'app-processo-lista',
  templateUrl: './processo-lista.component.html',
  styleUrl: './processo-lista.component.css'
})
export class ProcessoListaComponent implements OnChanges {

  @Input() servico?: string;
  @Input() processo?: string;
  @Input() titulo: string = 'Processos';

  processos: ProcessoExecucao[] = [];
  totalRecords: number = 0;
  loading: boolean = false;
  rows: number = 20;

  processoSelecionado?: ProcessoExecucaoDetalhe;
  exibirDetalhe: boolean = false;

  private ultimoEvento: TableLazyLoadEvent = { first: 0, rows: this.rows };

  constructor(private processoService: ProcessoService) { }

  ngOnChanges(changes: SimpleChanges): void {
    const mudouServico = changes['servico'] && !changes['servico'].firstChange;
    const mudouProcesso = changes['processo'] && !changes['processo'].firstChange;

    if (mudouServico || mudouProcesso) this.atualizar();
  }

  atualizar(): void {
    this.carregar({ ...this.ultimoEvento, first: 0 });
  }

  carregar(event: TableLazyLoadEvent): void {
    this.ultimoEvento = event;
    this.loading = true;

    const first = event.first ?? 0;
    const rows = event.rows ?? this.rows;
    const page = rows > 0 ? Math.floor(first / rows) : 0;

    const sortField = Array.isArray(event.sortField) ? event.sortField[0] : event.sortField;
    const sort = sortField
      ? `${sortField},${event.sortOrder === 1 ? 'asc' : 'desc'}`
      : undefined;

    const filtro: ProcessoFiltro = { servico: this.servico, processo: this.processo };

    this.processoService.getProcessos(filtro, page, rows, sort).subscribe({
      next: (data) => {
        this.processos = data.content;
        this.totalRecords = data.page.totalElements;
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }

  verDetalhe(processo: ProcessoExecucao): void {
    this.processoService.getProcesso(processo.id).subscribe(
      (data) => {
        this.processoSelecionado = data;
        this.exibirDetalhe = true;
      }
    );
  }

  severity(status: StatusProcesso): string {
    const map: Record<StatusProcesso, string> = {
      PENDENTE: 'secondary',
      EXECUTANDO: 'info',
      SUCESSO: 'success',
      PARCIAL: 'warning',
      ERRO: 'danger',
      ABANDONADO: 'contrast'
    };
    return map[status] ?? 'info';
  }

  formatarParametros(): string {
    if (!this.processoSelecionado?.parametros) return '';
    return JSON.stringify(this.processoSelecionado.parametros, null, 2);
  }

  formatarDetalhesEvento(evento: EventoProcesso): string {
    if (!evento.detalhes) return '';
    return JSON.stringify(evento.detalhes, null, 2);
  }
}
